import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {FileService} from '../files/file.service';
import {FilesModule} from '../files/files.module';
import {ModalModule} from '../modal/modal.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';

import {LegalReportsComponent} from './legal-reports.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    UiModule,
    PipesModule,
    FilesModule,
    ModalModule
  ],
  declarations: [
    LegalReportsComponent
  ],
  exports: [
    LegalReportsComponent
  ],
  providers: [FileService]
})

export class LegalReportsModule {
}
